<template>
<v-container fluid class="page-wrap fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>
      <v-col cols="12" sm="8" md="5" class="text-center">
        <v-card class="rounded-xl pa-8" elevation="3">
            <v-progress-circular
                indeterminate
                color="primary"
                size="48"
                width="4"
                class="mb-4"
            ></v-progress-circular>
            <div class="text-h6 font-weight-bold primary--text">Confirming Your Payment</div>
            <div class="text-body-2 grey--text mt-1">Please wait while we verify your transaction with Paystack...</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue';
  export default {
    name: 'VerifyTokenTopup',
    components: {
        HeaderVue,
    },
    mounted() {
        //console.log(new URL(document.referrer).hostname)
        //console.log(this.$route.query.plan)
        if (document.referrer && new URL(document.referrer).hostname == 'paystack') {
            this.updatePayment(this.$route.query.plan)
        }
        else{
            this.$router.push({name: 'ResultsDashboard'})
        }

    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : {},
    }),
    methods: {
        updatePayment (plan) {
            const payload = {
                plan: plan,
                school_id: this.school ? this.school.school_id : null,
            };
            axios.post(process.env.VUE_APP_BASEURL+'/payments',payload,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            })
            .then(() => {
                this.$router.push({name: 'ResultsDashboard'})
            })
            .catch((error) => {
                console.log(error.response)
                this.$router.push({name: 'ResultsDashboard'})
            })
            .finally(() => {
            });
        }
    },
  }
</script>
